(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cbn/cbn.module": [
		"./src/app/cbn/cbn.module.ts",
		"cbn-cbn-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/forgot-password/change-password/change-password.component.html":
/*!*********************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/forgot-password/change-password/change-password.component.html ***!
  \*********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<!-- [ Content ] Start -->\n<div class=\"authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4\"\n    style=\"background-image: url('assets/img/bg/21.jpg');\">\n    <div class=\"ui-bg-overlay bg-dark opacity-25\"></div>\n\n    <div class=\"authentication-inner py-5\">\n\n        <div class=\"card\">\n            <div class=\"p-4 p-sm-5\">\n                <!-- [ Logo ] Start -->\n                <div class=\"card-logo-cbn\" style=\"padding-bottom: 10%;\">\n                    <img src=\"assets/img/logo3.png\" alt=\"Brand Logo\" class=\"logo-cbn\">\n                </div>\n                <!-- [ Logo ] End -->\n\n                <!-- <h5 class=\"text-center text-muted font-weight-normal mb-4\">New password</h5> -->\n                <div *ngIf=\"error\" class=\"alert alert-danger mt-3 mb-0\">{{error}}</div>\n                <!-- Form -->\n                <form [formGroup]=\"changePasswordForm\" (ngSubmit)=\"onSubmit()\">\n                    <div class=\"form-group\">\n                        <label class=\"form-label d-flex justify-content-between align-items-end\">\n                            <span>New Password</span>\n                        </label>\n                        <input type=\"password\" formControlName=\"password\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && f.password.errors }\" />\n                        <div *ngIf=\"submitted && f.password.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"f.password.errors.required\">Password is required</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"d-flex justify-content-between align-items-center m-0\">\n                        <button class=\"btn btn-success  btn-block mt-4\">\n                            Change password\n                        </button>\n\n                    </div>\n                </form>\n                <!-- [ Form ] End -->\n\n            </div>\n\n        </div>\n\n    </div>\n</div>\n<!-- / Content -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/forgot-password/send-mail/send-mail.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/forgot-password/send-mail/send-mail.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [ Content ] Start -->\n<div class=\"authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4\"\n    style=\"background-image: url('assets/img/bg/21.jpg');\">\n    <div class=\"ui-bg-overlay bg-dark opacity-25\"></div>\n\n    <div class=\"authentication-inner py-5\">\n\n        <div class=\"card\">\n            <div class=\"p-4 p-sm-5\">\n                <!-- [ Logo ] Start -->\n                <div class=\"card-logo-cbn\" style=\"padding-bottom: 10%;\">\n                    <img src=\"assets/img/logo3.png\" alt=\"Brand Logo\" class=\"logo-cbn\">\n                </div>\n                <!-- [ Logo ] End -->\n\n                <h5 class=\"text-center text-muted font-weight-normal mb-4\">Forgot your password</h5>\n                <div *ngIf=\"error\" class=\"alert alert-danger mt-3 mb-0\">{{error}}</div>\n                <!-- Form -->\n                <form [formGroup]=\"forgotForm\" (ngSubmit)=\"onSubmit()\">\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Email</label>\n                        <input type=\"text\" formControlName=\"email\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && f.email.errors }\" />\n                        <div *ngIf=\"submitted && f.email.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"f.email.errors.required\">Email is required</div>\n                            <div *ngIf=\"f.email.errors.email\">Email must be a valid email address</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"d-flex justify-content-between align-items-center m-0\">\n                        <button class=\"btn btn-primary  btn-block mt-4\" [disabled]=\"onloading\">\n                            {{onloading ? 'Sending...' : 'Send mail'}}\n                        </button>\n                    </div>\n                </form>\n                <!-- [ Form ] End -->\n\n            </div>\n            <div class=\"text-center text-muted\" style=\"padding-bottom: 5%;\">\n                <a [routerLink]=\"['/login']\">Sign In</a>\n            </div>\n\n        </div>\n\n    </div>\n</div>\n<!-- / Content -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [ Content ] Start -->\n<div class=\"authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4\" style=\"background-image: url('assets/img/bg/21.jpg');\">\n    <div class=\"ui-bg-overlay bg-dark opacity-25\"></div>\n\n    <div class=\"authentication-inner py-5\">\n\n        <div class=\"card\">\n            <div class=\"p-4 p-sm-5\">\n                <!-- [ Logo ] Start -->\n                <div class=\"card-logo-cbn\" style=\"padding-bottom: 10%;\">\n                    <img src=\"assets/img/logo3.png\" alt=\"Brand Logo\" class=\"logo-cbn\">\n                </div>\n                <!-- [ Logo ] End -->\n\n                <h5 class=\"text-center text-muted font-weight-normal mb-4\">Login to Your Account</h5>\n                <!-- Form -->\n                <form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit()\">\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Username</label>\n                        <input type=\"text\" formControlName=\"username\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.username.errors }\" />\n                        <div *ngIf=\"submitted && f.username.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"f.username.errors.required\">Username is required</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label d-flex justify-content-between align-items-end\">\n                            <span>Password</span>\n                        </label>\n                        <input type=\"password\" formControlName=\"password\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.password.errors }\" />\n                        <div *ngIf=\"submitted && f.password.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"f.password.errors.required\">Password is required</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <p class=\"mb-0 text-align-end\">\n                        <a [routerLink]=\"['/forgot-password']\" class=\"small\">Forgot\n                            password?</a>\n                    </p>\n                    <div class=\"d-flex justify-content-between align-items-center m-0\">\n                        <button class=\"btn btn-primary  btn-block mt-4\">\n                            Login\n                        </button>\n\n                    </div>\n                </form>\n                <!-- [ Form ] End -->\n\n            </div>\n            <div class=\"card-footer py-3 px-4 px-sm-5\">\n                <div class=\"text-center text-muted\">\n                    Don't have an account yet?\n                    <a [routerLink]=\"['/' , AppURL.Register]\">Sign Up</a>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n<!-- / Content -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/register/register.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/register/register.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [ Content ] Start -->\n<div class=\"authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4\"\n    style=\"background-image: url('assets/img/bg/21.jpg');\">\n    <div class=\"ui-bg-overlay bg-dark opacity-25\"></div>\n\n    <div class=\"authentication-inner py-5\">\n\n        <div class=\"card\">\n            <div class=\"p-4 p-sm-5\">\n                <!-- [ Logo ] Start -->\n                <div class=\"card-logo-cbn\" style=\"padding-bottom: 10%;\">\n                    <img src=\"assets/img/logo3.png\" alt=\"Brand Logo\" class=\"logo-cbn\">\n                </div>\n                <!-- [ Logo ] End -->\n\n                <h5 class=\"text-center text-muted font-weight-normal mb-4\">Create an Account</h5>\n\n                <!-- Form -->\n                <form [formGroup]=\"signupForm\" (ngSubmit)=\"onSubmit()\">\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Username</label>\n                        <input type=\"text\" formControlName=\"username\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && s.username.errors }\" />\n                        <div *ngIf=\"submitted && s.username.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"s.username.errors.required\">Username is required</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Name <span class=\"valid\">*</span></label>\n                        <input type=\"text\" formControlName=\"name\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && s.name.errors }\" />\n                        <div *ngIf=\"submitted && s.name.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"s.name.errors.required\">Name is required</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Surname <span class=\"valid\">*</span></label>\n                        <input type=\"text\" formControlName=\"surname\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && s.surname.errors }\" />\n                        <div *ngIf=\"submitted && s.surname.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"s.surname.errors.required\">Surname is required</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Email </label>\n                        <input type=\"text\" formControlName=\"email\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && !signupForm.value.personal_phone && !signupForm.value.email}\" />\n                        <div *ngIf=\"submitted && !signupForm.value.personal_phone && !signupForm.value.email\"\n                            class=\"invalid-feedback\">\n                            <div>Please input email or mobile phone</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Mobile Phone</label>\n                        <input type=\"text\" (keypress)=\"keyPress($event)\" formControlName=\"personal_phone\" maxlength=\"10\"\n                            minlength=\"10\" placeholder=\"\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && !signupForm.value.personal_phone && !signupForm.value.email}\">\n                        <div *ngIf=\"submitted && !signupForm.value.personal_phone && !signupForm.value.email\"\n                            class=\"invalid-feedback\">\n                            <div>Please input mobile phone or email</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Password <span class=\"valid\">*</span></label>\n                        <input type=\"password\" formControlName=\"password\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && s.password.errors }\" />\n                        <div *ngIf=\"submitted && s.password.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"s.password.errors.required\">Password is required</div>\n                            <div *ngIf=\"s.password.errors.minlength\">Password must be at least 6 characters</div>\n                        </div>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"form-label\">Confirm Password <span class=\"valid\">*</span></label>\n                        <input type=\"password\" formControlName=\"confirmPassword\" class=\"form-control\"\n                            [ngClass]=\"{ 'is-invalid': submitted && s.confirmPassword.errors }\" />\n                        <div *ngIf=\"submitted && s.confirmPassword.errors\" class=\"invalid-feedback\">\n                            <div *ngIf=\"s.confirmPassword.errors.required\">Confirm Password is required</div>\n                            <div *ngIf=\"s.confirmPassword.errors.mustMatch\">Passwords must match</div>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label class=\"custom-control custom-checkbox d-block\"><input type=\"checkbox\"\n                                formControlName=\"agreeBox\" class=\"custom-control-input\"\n                                [ngClass]=\"{ 'is-invalid': submitted && s.agreeBox.errors }\"\n                                name=\"validation-checkbox-custom\" (click)=\"agreeSubmit()\"><span\n                                class=\"custom-control-label\">\n                                I accept the <u><a style=\"color: #716aca;\" data-toggle=\"modal\"\n                                        data-target=\"#modals-term\" (click)=\"getTerm()\">Terms and\n                                        Conditions</a></u></span>\n                        </label>\n                        <div class=\"clearfix\"></div>\n                    </div>\n                    <button type=\"submit\" class=\"btn btn-primary btn-block mt-4\" [disabled]=\"disable\"\n                        style=\"background-color: #28a9d0 !important;\">Sign Up</button>\n                </form>\n                <!-- [ Form ] End -->\n            </div>\n            <div class=\"card-footer py-3 px-4 px-sm-5\">\n                <div class=\"text-center text-muted\">\n                    Already have an account?\n                    <a [routerLink]=\"['/' , AppURL.Login]\">Sign In</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"modal fade\" id=\"modals-term\">\n            <div class=\"modal-dialog\">\n                <form class=\"modal-content\">\n                    <div class=\"modal-header\" style=\"display: unset; background-color: whitesmoke;\">\n                        <h5 class=\"modal-title\" style=\"padding-bottom: 15px;\">Terms and Conditions</h5>\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">×</button>\n                    </div>\n                    <div class=\"modal-body\">\n                        <p [innerHTML]=\"term\"></p>\n                    </div>\n                    <hr>\n                    <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n\n</div>\n<!-- / Content -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/verify-account/verify-account.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/verify-account/verify-account.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [ Content ] Start -->\n<div class=\"authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4\"\n    style=\"background-image: url('assets/img/bg/21.jpg');\">\n    <div class=\"ui-bg-overlay bg-dark opacity-25\"></div>\n\n    <div class=\"authentication-inner py-5\">\n\n        <div class=\"card\">\n            <div class=\"p-4 p-sm-5\">\n                <!-- [ Logo ] Start -->\n                <div class=\"card-logo-cbn\" *ngIf=\"status == true\">\n                    <img src=\"assets/img/verify.png\" alt=\"Brand Logo\" class=\"logo-cbn\" style=\"width: 100%; height: 100%;\">\n                </div>\n                <div class=\"card-logo-cbn\" *ngIf=\"status == false\">\n                    <img src=\"assets/img/verify-fail.png\" alt=\"Brand Logo\" class=\"logo-cbn\" style=\"width: 100%; height: 100%;\">\n                </div>\n                <!-- [ Logo ] End -->\n\n                <!-- <h5 class=\"text-center text-muted font-weight-normal mb-4\">Successfully verified</h5> -->\n                <div *ngIf=\"error\" class=\"alert alert-danger mt-3 mb-0\">{{error}}</div>\n                <!-- Form -->\n                <div class=\"d-flex justify-content-between align-items-center m-0\">\n                    <button class=\"btn btn-success  btn-block mt-4\" [routerLink]=\"['/login']\">\n                        <span class=\"spinner-border spinner-border-sm mr-1\"></span>\n                        Sign In\n                    </button>\n\n                </div>\n                <!-- [ Form ] End -->\n\n            </div>\n\n        </div>\n\n    </div>\n</div>\n<!-- / Content -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-content/auth-content.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-content/auth-content.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"layout-wrapper layout-2\">\n    <div class=\"layout-inner\">\n        <app-auth-sidebar></app-auth-sidebar>\n        <div class=\"layout-container\">\n            <app-auth-navber></app-auth-navber>\n            <div class=\"layout-content\">\n                <ng-content></ng-content>\n                <!-- <nav class=\"layout-footer footer bg-white\">\n                    <div\n                        class=\"container-fluid d-flex flex-wrap justify-content-between text-center container-p-x pb-3\">\n                        <div class=\"pt-3\">\n                            <span class=\"footer-text font-weight-semibold\">&copy; <a href=\"https://srthemesvilla.com\"\n                                    class=\"footer-link\" target=\"_blank\">CBN</a></span>\n                        </div>\n                    </div>\n                </nav> -->\n            </div>\n        </div>\n    </div>\n    <div class=\"layout-overlay layout-sidenav-toggle\" (click)=\"toggleSidebar()\"></div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-navber/auth-navber.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-navber/auth-navber.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [ Layout navbar ( Header ) ] Start -->\n<nav class=\"layout-navbar navbar navbar-expand-lg align-items-lg-center bg-white container-p-x\" id=\"layout-navbar\"\n    style=\"padding: 0;background-color: transparent !important;\" id=\"mobile\">\n\n    <!-- Brand demo (see assets/css/demo/demo.css) -->\n\n    <!-- Sidenav toggle (see assets/css/demo/demo.css) -->\n    <div class=\"layout-sidenav-toggle navbar-nav d-lg-none align-items-lg-center mr-auto\">\n        <a class=\"nav-item nav-link px-0 mr-lg-4\" href=\"javascript:\" (click)=\"toggleSidebar()\">\n            <i class=\"ion ion-md-menu text-large align-middle\"></i>\n        </a>\n    </div>\n\n    <span style=\"margin: auto;margin-left: unset;\" id=\"showLogoDashboard\" class=\"hide-logo\">\n        <img src=\"assets/img/logo3.png\" style=\"width: 100px; margin: auto;\" alt=\"Brand Logo\" class=\"img-fluid\">\n    </span>\n\n    <span class=\"d-inline-flex flex-lg-row-reverse align-items-center align-middle\" id=\"hideLogoDashboard\">\n        <img src=\"assets/img/logo3.png\" style=\"width: 100px; margin: auto;\" alt=\"Brand Logo\" class=\"img-fluid\">\n    </span>\n</nav>\n<!-- [ Layout navbar ( Header ) ] End -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-sidebar/auth-sidebar.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-sidebar/auth-sidebar.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- [ Layout sidenav ] Start -->\n<div class=\"my-overlay\" *ngIf=\"showOverlay\">\n    <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n</div>\n<div id=\"layout-sidenav\" class=\"layout-sidenav sidenav sidenav-vertical bg-dark\">\n    <!-- Brand demo (see assets/css/demo/demo.css) -->\n    <div class=\"app-brand demo\">\n        <!-- <span class=\"app-brand-logo demo\"> -->\n        <span class=\"d-inline-flex align-items-center\" style=\"padding: inherit;\">\n            <img src=\"assets/img/avatars/1.png\" alt class=\"d-block ui-w-30 rounded-circle\" *ngIf=\"avatar == ''\">\n            <img src=\"{{url}}/avatar/{{avatar}}\" alt class=\"d-block ui-w-30 rounded-circle\"\n                style=\"width: 30px; height: 30px;\" *ngIf=\"avatar !== ''\">\n            <span class=\"px-1 mr-lg-2 ml-2 ml-lg-0\"\n                style=\"margin-left: 0.5rem !important; font-size: 16px;\">{{displayName}}</span>\n        </span>\n    </div>\n\n    <!-- Links -->\n    <ul class=\"sidenav-inner py-1\" routerLinkActive=\"active-link\" [routerLinkActiveOptions]=\"{exact:\n    true}\">\n\n        <!-- Dashboards -->\n        <li class=\"sidenav-item sidenav-space\" routerLinkActive=\"active\">\n            <a [routerLink]=\"['/' , AppURL.Authen, AuthURL.Dashboard]\" class=\"sidenav-link\" routerLinkActive=\"active\" (click)=\"toggleSidebar()\">\n                <div>Home</div>\n            </a>\n        </li>\n\n        <!-- Layouts -->\n\n        <!-- <li class=\"sidenav-header small font-weight-semibold\">Module</li> -->\n\n        <li class=\"sidenav-item\" id=\"checkActive\" routerLinkActive=\"{{ setActive() }}\">\n            <a class=\"sidenav-link\" (click)=\"toggleSidebar()\" [routerLink]=\"['/', AppURL.Authen, AuthURL.Projects]\" id=\"checkActive-text\" routerLinkActive=\"{{ setActive() }}\">\n                <div>Your Donate</div>\n            </a>\n        </li>\n\n        <!-- Setting -->\n        <li class=\"sidenav-item sidenav-space\" id=\"oz-checkActive\" routerLinkActive=\"{{ setActive() }}\">\n            <a [routerLink]=\"['/', AppURL.Authen, AuthURL.Organizations]\" class=\"sidenav-link\" (click)=\"toggleSidebar()\" routerLinkActive=\"{{ setActive() }}\" id=\"oz-checkActive-text\">\n                <div>Corporate Donate</div>\n            </a>\n        </li>\n\n        <!-- <li class=\"sidenav-header small font-weight-semibold\">Setting</li> -->\n        <li class=\"sidenav-item\" routerLinkActive=\"active\">\n            <a [routerLink]=\"['/', AppURL.Authen, AuthURL.Profile]\" class=\"sidenav-link\" (click)=\"toggleSidebar()\" routerLinkActive=\"active\">\n                <div>Account Setting</div>\n            </a>\n        </li>\n        <li class=\"sidenav-item\">\n            <a (click)=\"logout()\" style=\"cursor: pointer;\" class=\"sidenav-link\" (click)=\"toggleSidebar()\">\n                <div>Log Out</div>\n            </a>\n        </li>\n    </ul>\n</div>\n<!-- [ Layout sidenav ] End -->");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _app_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app.url */ "./src/app/app.url.ts");
/* harmony import */ var _components_helpers_auth_guard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/_helpers/auth.guard */ "./src/app/components/_helpers/auth.guard.ts");
/* harmony import */ var _components_helpers_logout_guard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/_helpers/logout.guard */ "./src/app/components/_helpers/logout.guard.ts");
/* harmony import */ var _components_login_login_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/login/login.component */ "./src/app/components/login/login.component.ts");
/* harmony import */ var _components_register_register_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/register/register.component */ "./src/app/components/register/register.component.ts");
/* harmony import */ var _components_forgot_password_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/forgot-password/change-password/change-password.component */ "./src/app/components/forgot-password/change-password/change-password.component.ts");
/* harmony import */ var _components_forgot_password_send_mail_send_mail_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/forgot-password/send-mail/send-mail.component */ "./src/app/components/forgot-password/send-mail/send-mail.component.ts");
/* harmony import */ var _components_verify_account_verify_account_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/verify-account/verify-account.component */ "./src/app/components/verify-account/verify-account.component.ts");











const routes = [
    { path: '', redirectTo: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].Login, pathMatch: 'full' },
    { path: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].Login, component: _components_login_login_component__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"], canActivate: [_components_helpers_logout_guard__WEBPACK_IMPORTED_MODULE_5__["LogoutGuard"]] },
    { path: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].Register, component: _components_register_register_component__WEBPACK_IMPORTED_MODULE_7__["RegisterComponent"], canActivate: [_components_helpers_logout_guard__WEBPACK_IMPORTED_MODULE_5__["LogoutGuard"]] },
    { path: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].ForGotPassWord, component: _components_forgot_password_send_mail_send_mail_component__WEBPACK_IMPORTED_MODULE_9__["SendMailComponent"], canActivate: [_components_helpers_logout_guard__WEBPACK_IMPORTED_MODULE_5__["LogoutGuard"]] },
    { path: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].ChangePassWord + '/:uid', component: _components_forgot_password_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_8__["ChangePasswordComponent"], canActivate: [_components_helpers_logout_guard__WEBPACK_IMPORTED_MODULE_5__["LogoutGuard"]] },
    { path: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].VerifyEmail + '/:uid', component: _components_verify_account_verify_account_component__WEBPACK_IMPORTED_MODULE_10__["VerifyAccountComponent"], canActivate: [_components_helpers_logout_guard__WEBPACK_IMPORTED_MODULE_5__["LogoutGuard"]] },
    { path: _app_url__WEBPACK_IMPORTED_MODULE_3__["AppURL"].Authen, loadChildren: './cbn/cbn.module#CbnModule', canActivate: [_components_helpers_auth_guard__WEBPACK_IMPORTED_MODULE_4__["AuthGuard"]] }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'cbn';
    }
    ngOnInit() {
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _components_login_login_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/login/login.component */ "./src/app/components/login/login.component.ts");
/* harmony import */ var _components_register_register_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/register/register.component */ "./src/app/components/register/register.component.ts");
/* harmony import */ var _shareds_shareds_module__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./shareds/shareds.module */ "./src/app/shareds/shareds.module.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var angular_datatables__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! angular-datatables */ "./node_modules/angular-datatables/index.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _components_forgot_password_send_mail_send_mail_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/forgot-password/send-mail/send-mail.component */ "./src/app/components/forgot-password/send-mail/send-mail.component.ts");
/* harmony import */ var _components_forgot_password_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/forgot-password/change-password/change-password.component */ "./src/app/components/forgot-password/change-password/change-password.component.ts");
/* harmony import */ var _components_verify_account_verify_account_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/verify-account/verify-account.component */ "./src/app/components/verify-account/verify-account.component.ts");
/* harmony import */ var ngx_bootstrap_carousel__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ngx-bootstrap/carousel */ "./node_modules/ngx-bootstrap/carousel/fesm2015/ngx-bootstrap-carousel.js");
/* harmony import */ var ngx_bootstrap_datepicker__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ngx-bootstrap/datepicker */ "./node_modules/ngx-bootstrap/datepicker/fesm2015/ngx-bootstrap-datepicker.js");


















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
            _components_login_login_component__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"],
            _components_register_register_component__WEBPACK_IMPORTED_MODULE_7__["RegisterComponent"],
            _components_forgot_password_send_mail_send_mail_component__WEBPACK_IMPORTED_MODULE_13__["SendMailComponent"],
            _components_forgot_password_change_password_change_password_component__WEBPACK_IMPORTED_MODULE_14__["ChangePasswordComponent"],
            _components_verify_account_verify_account_component__WEBPACK_IMPORTED_MODULE_15__["VerifyAccountComponent"],
        ],
        imports: [
            angular_datatables__WEBPACK_IMPORTED_MODULE_10__["DataTablesModule"],
            ngx_toastr__WEBPACK_IMPORTED_MODULE_9__["ToastrModule"].forRoot(),
            _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_12__["ReactiveFormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_11__["BrowserAnimationsModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _shareds_shareds_module__WEBPACK_IMPORTED_MODULE_8__["SharedsModule"],
            ngx_bootstrap_datepicker__WEBPACK_IMPORTED_MODULE_17__["BsDatepickerModule"].forRoot(),
            ngx_bootstrap_carousel__WEBPACK_IMPORTED_MODULE_16__["CarouselModule"].forRoot(),
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/app.url.ts":
/*!****************************!*\
  !*** ./src/app/app.url.ts ***!
  \****************************/
/*! exports provided: AppURL */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppURL", function() { return AppURL; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const AppURL = {
    Login: 'login',
    Register: 'register',
    ForGotPassWord: 'forgot-password',
    ChangePassWord: 'change-password',
    VerifyEmail: 'verify-email',
    Authen: 'cbn',
};


/***/ }),

/***/ "./src/app/cbn/cbn.url.ts":
/*!********************************!*\
  !*** ./src/app/cbn/cbn.url.ts ***!
  \********************************/
/*! exports provided: AuthURL */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthURL", function() { return AuthURL; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const AuthURL = {
    Dashboard: 'dashboard',
    Setting: 'setting',
    Profile: 'profile',
    UserAddress: 'user-update-address',
    Projects: 'projects',
    ProjectsList: 'projects-list',
    ProjectAddMember: 'project-add-member',
    ProjectView: 'project-view',
    ProjectPaymentView: 'project-payment-view',
    ProjectPaymentCreate: 'project-payment-create',
    PaymentPay: 'payment-pay',
    OrganizationProjectView: 'organization-project-view',
    OrganizationProjectViewPayment: 'organization-project-view-payment',
    Organizations: 'organizations',
    OrganizationsCreate: 'organizations-create',
    OrganizationsList: 'organizations-list',
    OrganizationProjectsList: 'organization-projects-list',
    OrganizationProjectsAddMember: 'organization-projects-add-member',
    OrganizationAddMember: 'organization-add-member',
    OrganizationView: 'organization-view',
    OrganizationPaymentCreate: 'organization-payment-create',
    OrganizationPaymentView: 'organization-payment-view',
    OrganizationAddress: 'organization-update-address',
    OrganizationInfo: 'organization-infomation'
};


/***/ }),

/***/ "./src/app/cbn/components/profile/_services/profile.service.ts":
/*!*********************************************************************!*\
  !*** ./src/app/cbn/components/profile/_services/profile.service.ts ***!
  \*********************************************************************/
/*! exports provided: ProfileService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProfileService", function() { return ProfileService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");





let ProfileService = class ProfileService {
    constructor(http) {
        this.http = http;
        this.list = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
        this.list$ = this.list.asObservable();
        this.avatar = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
        this.avatar$ = this.avatar.asObservable();
        const dataUSer = JSON.parse(localStorage.getItem('currentUser'));
        this.token = dataUSer.token.access_token;
        this.userId = dataUSer.data.uid;
    }
    displayUsername(name) {
        this.list.next(name);
    }
    displayAvatar(avatar) {
        this.avatar.next(avatar);
    }
    updateAvatar(body, uid) {
        return this.http.put(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/avatar/${uid}`, body, {
            headers: {
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getUserByID(uid) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/user/${uid}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getProvinces() {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/provinces`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getProvinceByID(id) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/province/${id}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getDistrictsByProvinceId(provinceId) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/districts/${provinceId}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getDistrictsByID(id) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/district/${id}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getSubDistrictsByDistrictId(districtId) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/subdistricts/${districtId}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getSubDistrictsByID(id) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/subdistrict/${id}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getUsers() {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/users`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    updateProfile(body, uid) {
        return this.http.put(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/user/update/${uid}`, body, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getProfile() {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/user/${this.userId}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    getPhoneNumberByUID(uid) {
        return this.http.get(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/get/v2/phonenumbers/${uid}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    createAddressOffice(uid, body) {
        return this.http.post(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/create/office/address/${uid}`, body, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    createAddressShipping(uid, body) {
        return this.http.post(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/create/shipping/address/${uid}`, body, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    updateAddressOffice(id, body) {
        return this.http.put(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/put/address/${id}/office`, body, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    updateAddressShipping(id, body) {
        return this.http.put(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/put/address/${id}/shipping`, body, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    createPhoneNumber(body) {
        return this.http.post(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/create/phonenumber`, body, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    deletePhoneNumber(id) {
        return this.http.delete(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/delete/phonenumbers/${id}`, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
    checkOldPassword(password, uid) {
        return this.http.post(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/check/old/password/${uid}`, { password }, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: 'Bearer ' + this.token
            }
        });
    }
};
ProfileService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
ProfileService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ProfileService);



/***/ }),

/***/ "./src/app/components/_helpers/auth.guard.ts":
/*!***************************************************!*\
  !*** ./src/app/components/_helpers/auth.guard.ts ***!
  \***************************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_authen_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_services/authen.service */ "./src/app/components/_services/authen.service.ts");




let AuthGuard = class AuthGuard {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    canActivate(route, state) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_authen_service__WEBPACK_IMPORTED_MODULE_3__["AuthenService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], AuthGuard);



/***/ }),

/***/ "./src/app/components/_helpers/logout.guard.ts":
/*!*****************************************************!*\
  !*** ./src/app/components/_helpers/logout.guard.ts ***!
  \*****************************************************/
/*! exports provided: LogoutGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogoutGuard", function() { return LogoutGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_authen_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_services/authen.service */ "./src/app/components/_services/authen.service.ts");




let LogoutGuard = class LogoutGuard {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    canActivate(route, state) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/cbn'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        // logged in so return true
        return true;
    }
};
LogoutGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_authen_service__WEBPACK_IMPORTED_MODULE_3__["AuthenService"] }
];
LogoutGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], LogoutGuard);



/***/ }),

/***/ "./src/app/components/_helpers/must-match.ts":
/*!***************************************************!*\
  !*** ./src/app/components/_helpers/must-match.ts ***!
  \***************************************************/
/*! exports provided: MustMatch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MustMatch", function() { return MustMatch; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

// custom validator to check that two fields match
function MustMatch(controlName, matchingControlName) {
    return (formGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }
        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        }
        else {
            matchingControl.setErrors(null);
        }
    };
}


/***/ }),

/***/ "./src/app/components/_services/authen.service.ts":
/*!********************************************************!*\
  !*** ./src/app/components/_services/authen.service.ts ***!
  \********************************************************/
/*! exports provided: AuthenService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenService", function() { return AuthenService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../environments/environment */ "./src/environments/environment.ts");






let AuthenService = class AuthenService {
    constructor(http) {
        this.http = http;
        this.currentUserSubject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    getTerm() {
        return this.http.get(`${_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].apiUrl}/get/term/user`);
    }
    login(username, password) {
        return this.http.post(`${_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].apiUrl}/signin`, { username, password })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])((response) => {
            if (response.status === true) {
                localStorage.setItem('currentUser', JSON.stringify(response));
                localStorage.setItem('UserID', response.data.uid);
                this.currentUserSubject.next(response);
                return response;
            }
            else {
                return response;
            }
        }));
    }
    sendMailForgotPassword(body) {
        return this.http.post(`${_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].apiUrl}/sendmail/reset/password`, body);
    }
    changePassword(body, uid) {
        return this.http.post(`${_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].apiUrl}/reset/${uid}/password`, body);
    }
    signup(body) {
        return this.http.post(`${_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].apiUrl}/signup`, body);
    }
    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('UserID');
        this.currentUserSubject.next(null);
    }
};
AuthenService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
AuthenService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], AuthenService);



/***/ }),

/***/ "./src/app/components/forgot-password/change-password/change-password.component.css":
/*!******************************************************************************************!*\
  !*** ./src/app/components/forgot-password/change-password/change-password.component.css ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".logo-cbn {\n    width: 150px;\n    height: 100px;\n    margin: auto;\n    display: block;\n  }\n  \n  \n  .authentication-wrapper {\n    display: flex;\n    flex-basis: 100%;\n    min-height: 100vh;\n    width: 100%;\n  }\n  \n  \n  .authentication-wrapper .authentication-inner {\n    width: 100%;\n  }\n  \n  \n  .authentication-wrapper.authentication-1, .authentication-wrapper.authentication-2, .authentication-wrapper.authentication-4 {\n    align-items: center;\n    justify-content: center;\n  }\n  \n  \n  .authentication-wrapper.authentication-1 .authentication-inner {\n    max-width: 300px;\n  }\n  \n  \n  .authentication-wrapper.authentication-2 .authentication-inner {\n    max-width: 380px;\n  }\n  \n  \n  .authentication-wrapper.authentication-3 {\n    align-items: stretch;\n    justify-content: stretch;\n  }\n  \n  \n  .authentication-wrapper.authentication-3 .authentication-inner {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    justify-content: stretch;\n  }\n  \n  \n  .authentication-wrapper.authentication-4 .authentication-inner {\n    max-width: 800px;\n  }\n  \n  \n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .authentication-wrapper:after {\n      content: '';\n      display: block;\n      flex: 0 0 0;\n      min-height: inherit;\n      width: 0;\n      font-size: 0;\n    }\n  }\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/forgot-password/change-password/change-password.component.ts":
/*!*****************************************************************************************!*\
  !*** ./src/app/components/forgot-password/change-password/change-password.component.ts ***!
  \*****************************************************************************************/
/*! exports provided: ChangePasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangePasswordComponent", function() { return ChangePasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_authen_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../_services/authen.service */ "./src/app/components/_services/authen.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");







let ChangePasswordComponent = class ChangePasswordComponent {
    constructor(formBuilder, route, router, authenticationService, toastr) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.toastr = toastr;
        this.submitted = false;
        this.error = '';
        this.uid = this.route.snapshot.params.uid;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }
    ngOnInit() {
        this.changePasswordForm = this.formBuilder.group({
            password: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]]
        });
    }
    // convenience getter for easy access to form fields
    get f() { return this.changePasswordForm.controls; }
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.changePasswordForm.invalid) {
            return;
        }
        this.authenticationService.changePassword(this.changePasswordForm.value, this.uid)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["first"])())
            .subscribe(data => {
            if (data.status === true) {
                this.toastr.success(data.message, 'Notice!');
                this.router.navigate(['/login']);
            }
            else {
                this.toastr.error(data.message);
            }
        }, error => {
            this.error = error;
        });
    }
};
ChangePasswordComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_authen_service__WEBPACK_IMPORTED_MODULE_5__["AuthenService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_6__["ToastrService"] }
];
ChangePasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-change-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./change-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/forgot-password/change-password/change-password.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./change-password.component.css */ "./src/app/components/forgot-password/change-password/change-password.component.css")).default]
    })
], ChangePasswordComponent);



/***/ }),

/***/ "./src/app/components/forgot-password/send-mail/send-mail.component.css":
/*!******************************************************************************!*\
  !*** ./src/app/components/forgot-password/send-mail/send-mail.component.css ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".logo-cbn {\n    width: 150px;\n    height: 100px;\n    margin: auto;\n    display: block;\n  }\n  \n  \n  .authentication-wrapper {\n    display: flex;\n    flex-basis: 100%;\n    min-height: 100vh;\n    width: 100%;\n  }\n  \n  \n  .authentication-wrapper .authentication-inner {\n    width: 100%;\n  }\n  \n  \n  .authentication-wrapper.authentication-1, .authentication-wrapper.authentication-2, .authentication-wrapper.authentication-4 {\n    align-items: center;\n    justify-content: center;\n  }\n  \n  \n  .authentication-wrapper.authentication-1 .authentication-inner {\n    max-width: 300px;\n  }\n  \n  \n  .authentication-wrapper.authentication-2 .authentication-inner {\n    max-width: 380px;\n  }\n  \n  \n  .authentication-wrapper.authentication-3 {\n    align-items: stretch;\n    justify-content: stretch;\n  }\n  \n  \n  .authentication-wrapper.authentication-3 .authentication-inner {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    justify-content: stretch;\n  }\n  \n  \n  .authentication-wrapper.authentication-4 .authentication-inner {\n    max-width: 800px;\n  }\n  \n  \n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .authentication-wrapper:after {\n      content: '';\n      display: block;\n      flex: 0 0 0;\n      min-height: inherit;\n      width: 0;\n      font-size: 0;\n    }\n  }\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/forgot-password/send-mail/send-mail.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/components/forgot-password/send-mail/send-mail.component.ts ***!
  \*****************************************************************************/
/*! exports provided: SendMailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SendMailComponent", function() { return SendMailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_authen_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../_services/authen.service */ "./src/app/components/_services/authen.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");







let SendMailComponent = class SendMailComponent {
    constructor(formBuilder, route, router, authenticationService, toastr) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.toastr = toastr;
        this.submitted = false;
        this.error = '';
        this.onloading = false;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }
    ngOnInit() {
        this.forgotForm = this.formBuilder.group({
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].email]]
        });
    }
    // convenience getter for easy access to form fields
    get f() { return this.forgotForm.controls; }
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.forgotForm.invalid) {
            return;
        }
        this.onloading = true;
        // return
        this.authenticationService.sendMailForgotPassword(this.forgotForm.value)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["first"])())
            .subscribe(data => {
            if (data.status === true) {
                this.onloading = false;
                this.toastr.success('Please check your email for change password', 'Notice!');
                this.router.navigate(['/login']);
            }
            else {
                this.onloading = false;
                this.toastr.error(data.message);
            }
        }, error => {
            this.error = 'Serve error, Can\'t send email for change password';
        });
    }
};
SendMailComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_authen_service__WEBPACK_IMPORTED_MODULE_5__["AuthenService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_6__["ToastrService"] }
];
SendMailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-send-mail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./send-mail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/forgot-password/send-mail/send-mail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./send-mail.component.css */ "./src/app/components/forgot-password/send-mail/send-mail.component.css")).default]
    })
], SendMailComponent);



/***/ }),

/***/ "./src/app/components/login/login.component.css":
/*!******************************************************!*\
  !*** ./src/app/components/login/login.component.css ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".logo-cbn {\n    width: 150px;\n    height: 100px;\n    margin: auto;\n    display: block;\n}\n\n.text-align-end {\n    text-align: end;\n}\n\n.authentication-wrapper {\n    display: flex;\n    flex-basis: 100%;\n    min-height: 100vh;\n    width: 100%;\n}\n\n.authentication-wrapper .authentication-inner {\n    width: 100%;\n}\n\n.authentication-wrapper.authentication-1,\n.authentication-wrapper.authentication-2,\n.authentication-wrapper.authentication-4 {\n    align-items: center;\n    justify-content: center;\n}\n\n.authentication-wrapper.authentication-1 .authentication-inner {\n    max-width: 300px;\n}\n\n.authentication-wrapper.authentication-2 .authentication-inner {\n    max-width: 380px;\n}\n\n.authentication-wrapper.authentication-3 {\n    align-items: stretch;\n    justify-content: stretch;\n}\n\n.authentication-wrapper.authentication-3 .authentication-inner {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    justify-content: stretch;\n}\n\n.authentication-wrapper.authentication-4 .authentication-inner {\n    max-width: 800px;\n}\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .authentication-wrapper:after {\n        content: '';\n        display: block;\n        flex: 0 0 0;\n        min-height: inherit;\n        width: 0;\n        font-size: 0;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/login/login.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/components/login/login.component.ts ***!
  \*****************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_authen_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_services/authen.service */ "./src/app/components/_services/authen.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _app_url__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../app.url */ "./src/app/app.url.ts");
/* harmony import */ var _cbn_cbn_url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../cbn/cbn.url */ "./src/app/cbn/cbn.url.ts");









let LoginComponent = class LoginComponent {
    constructor(formBuilder, route, router, authenticationService, toastr) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.toastr = toastr;
        this.submitted = false;
        this.error = '';
        this.AppURL = _app_url__WEBPACK_IMPORTED_MODULE_7__["AppURL"];
        this.AuthURL = _cbn_cbn_url__WEBPACK_IMPORTED_MODULE_8__["AuthURL"];
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }
    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            password: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]
        });
    }
    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["first"])())
            .subscribe(data => {
            if (data.status === true) {
                this.toastr.success('Login Successfully', 'Notice!');
                this.router.navigate(['/cbn']);
            }
            else {
                this.toastr.error(data.message);
            }
        }, error => {
            this.error = error;
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_authen_service__WEBPACK_IMPORTED_MODULE_5__["AuthenService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_6__["ToastrService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/components/login/login.component.css")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/components/register/register.component.css":
/*!************************************************************!*\
  !*** ./src/app/components/register/register.component.css ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".logo-cbn {\n    width: 150px;\n    height: 100px;\n    margin: auto;\n    display: block;\n  }\n\nspan.valid {\n    color: brown;\n}\n\n.authentication-wrapper {\n    display: flex;\n    flex-basis: 100%;\n    min-height: 100vh;\n    width: 100%;\n}\n\n.authentication-wrapper .authentication-inner {\n    width: 100%;\n}\n\n.authentication-wrapper.authentication-1,\n.authentication-wrapper.authentication-2,\n.authentication-wrapper.authentication-4 {\n    align-items: center;\n    justify-content: center;\n}\n\n.authentication-wrapper.authentication-1 .authentication-inner {\n    max-width: 300px;\n}\n\n.authentication-wrapper.authentication-2 .authentication-inner {\n    max-width: 380px;\n}\n\n.authentication-wrapper.authentication-3 {\n    align-items: stretch;\n    justify-content: stretch;\n}\n\n.authentication-wrapper.authentication-3 .authentication-inner {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    justify-content: stretch;\n}\n\n.authentication-wrapper.authentication-4 .authentication-inner {\n    max-width: 800px;\n}\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .authentication-wrapper:after {\n        content: '';\n        display: block;\n        flex: 0 0 0;\n        min-height: inherit;\n        width: 0;\n        font-size: 0;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/register/register.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/components/register/register.component.ts ***!
  \***********************************************************/
/*! exports provided: RegisterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RegisterComponent", function() { return RegisterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_app_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/app.url */ "./src/app/app.url.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _services_authen_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../_services/authen.service */ "./src/app/components/_services/authen.service.ts");
/* harmony import */ var _helpers_must_match__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../_helpers/must-match */ "./src/app/components/_helpers/must-match.ts");










let RegisterComponent = class RegisterComponent {
    constructor(formBuilder, router, toastr, authenticationService) {
        this.formBuilder = formBuilder;
        this.router = router;
        this.toastr = toastr;
        this.authenticationService = authenticationService;
        this.loading = false;
        this.disable = true;
        this.submitted = false;
        this.error = '';
        this.AppURL = src_app_app_url__WEBPACK_IMPORTED_MODULE_2__["AppURL"];
    }
    ngOnInit() {
        this.signupForm = this.formBuilder.group({
            username: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            surname: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            email: [''],
            password: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].minLength(6)]],
            confirmPassword: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            agreeBox: [false, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].requiredTrue],
            personal_phone: ['']
        }, {
            validator: Object(_helpers_must_match__WEBPACK_IMPORTED_MODULE_9__["MustMatch"])('password', 'confirmPassword')
        });
    }
    get s() { return this.signupForm.controls; }
    getTerm() {
        this.authenticationService.getTerm()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["first"])())
            .subscribe((response) => {
            if (response.status === true) {
                this.term = response.data.content;
            }
        }, error => {
            this.error = error;
        });
    }
    agreeSubmit() {
        if (this.disable) {
            this.disable = false;
        }
        else {
            this.disable = true;
        }
    }
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.signupForm.invalid) {
            return;
        }
        if (this.signupForm.value.email == '' && this.signupForm.value.personal_phone == '') {
            return;
        }
        this.loading = true;
        let timerInterval;
        sweetalert2__WEBPACK_IMPORTED_MODULE_7___default.a.fire({
            title: 'Please wait...',
            html: 'Registering...',
            onBeforeOpen: () => {
                sweetalert2__WEBPACK_IMPORTED_MODULE_7___default.a.showLoading();
            },
            onClose: () => {
                clearInterval(timerInterval);
            }
        }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === sweetalert2__WEBPACK_IMPORTED_MODULE_7___default.a.DismissReason.timer) {
                console.log('I was closed by the timer');
            }
        });
        this.authenticationService.signup(this.signupForm.value)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["first"])())
            .subscribe((response) => {
            if (response.status === true) {
                sweetalert2__WEBPACK_IMPORTED_MODULE_7___default.a.fire('Successful!', response.message, 'success');
                this.router.navigate(['/login']);
            }
            else {
                this.error = response.message;
                sweetalert2__WEBPACK_IMPORTED_MODULE_7___default.a.fire('Fail!', response.message, 'error');
            }
        }, error => {
            this.error = error;
            this.loading = false;
        });
    }
    keyPress(event) {
        const pattern = /[0-9\+\-\ ]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode !== 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }
};
RegisterComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_6__["ToastrService"] },
    { type: _services_authen_service__WEBPACK_IMPORTED_MODULE_8__["AuthenService"] }
];
RegisterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-register',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./register.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/register/register.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./register.component.css */ "./src/app/components/register/register.component.css")).default]
    })
], RegisterComponent);



/***/ }),

/***/ "./src/app/components/verify-account/_services/verify.service.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/verify-account/_services/verify.service.ts ***!
  \***********************************************************************/
/*! exports provided: VerifyService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VerifyService", function() { return VerifyService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");




let VerifyService = class VerifyService {
    constructor(http) {
        this.http = http;
    }
    verifiyAccount(uid) {
        return this.http.post(`${src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl}/verification/${uid}`, {});
    }
};
VerifyService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
VerifyService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], VerifyService);



/***/ }),

/***/ "./src/app/components/verify-account/verify-account.component.css":
/*!************************************************************************!*\
  !*** ./src/app/components/verify-account/verify-account.component.css ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".logo-cbn {\n    width: 150px;\n    height: 100px;\n    margin: auto;\n    display: block;\n  }\n  \n  \n  .authentication-wrapper {\n    display: flex;\n    flex-basis: 100%;\n    min-height: 100vh;\n    width: 100%;\n  }\n  \n  \n  .authentication-wrapper .authentication-inner {\n    width: 100%;\n  }\n  \n  \n  .authentication-wrapper.authentication-1, .authentication-wrapper.authentication-2, .authentication-wrapper.authentication-4 {\n    align-items: center;\n    justify-content: center;\n  }\n  \n  \n  .authentication-wrapper.authentication-1 .authentication-inner {\n    max-width: 300px;\n  }\n  \n  \n  .authentication-wrapper.authentication-2 .authentication-inner {\n    max-width: 380px;\n  }\n  \n  \n  .authentication-wrapper.authentication-3 {\n    align-items: stretch;\n    justify-content: stretch;\n  }\n  \n  \n  .authentication-wrapper.authentication-3 .authentication-inner {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    justify-content: stretch;\n  }\n  \n  \n  .authentication-wrapper.authentication-4 .authentication-inner {\n    max-width: 800px;\n  }\n  \n  \n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .authentication-wrapper:after {\n      content: '';\n      display: block;\n      flex: 0 0 0;\n      min-height: inherit;\n      width: 0;\n      font-size: 0;\n    }\n  }\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/verify-account/verify-account.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/verify-account/verify-account.component.ts ***!
  \***********************************************************************/
/*! exports provided: VerifyAccountComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VerifyAccountComponent", function() { return VerifyAccountComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _verify_account_services_verify_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../verify-account/_services/verify.service */ "./src/app/components/verify-account/_services/verify.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");






let VerifyAccountComponent = class VerifyAccountComponent {
    constructor(route, toastr, vfService) {
        this.route = route;
        this.toastr = toastr;
        this.vfService = vfService;
        this.status = false;
        this.uid = this.route.snapshot.params.uid;
    }
    ngOnInit() {
        this.verifiedAccount();
    }
    verifiedAccount() {
        this.vfService.verifiyAccount(this.uid)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["first"])())
            .subscribe((response) => {
            if (response.status === true) {
                this.status = response.status;
                this.toastr.success(response.message, 'Notice!');
            }
            else {
                this.status = response.status;
                this.toastr.error(response.message);
            }
        }, error => {
            this.error = error;
        });
    }
};
VerifyAccountComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_5__["ToastrService"] },
    { type: _verify_account_services_verify_service__WEBPACK_IMPORTED_MODULE_4__["VerifyService"] }
];
VerifyAccountComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-verify-account',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./verify-account.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/verify-account/verify-account.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./verify-account.component.css */ "./src/app/components/verify-account/verify-account.component.css")).default]
    })
], VerifyAccountComponent);



/***/ }),

/***/ "./src/app/shareds/components/auth-content/auth-content.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/shareds/components/auth-content/auth-content.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZHMvY29tcG9uZW50cy9hdXRoLWNvbnRlbnQvYXV0aC1jb250ZW50LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/shareds/components/auth-content/auth-content.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/shareds/components/auth-content/auth-content.component.ts ***!
  \***************************************************************************/
/*! exports provided: AuthContentComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthContentComponent", function() { return AuthContentComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AuthContentComponent = class AuthContentComponent {
    constructor() { }
    ngOnInit() {
        App.initialLoadPage();
        SideBar.initialLoadFunction();
    }
    toggleSidebar() {
        // layout-expanded
        var element = document.getElementById("html");
        element.classList.remove("layout-expanded");
    }
};
AuthContentComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-auth-content',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./auth-content.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-content/auth-content.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./auth-content.component.css */ "./src/app/shareds/components/auth-content/auth-content.component.css")).default]
    })
], AuthContentComponent);



/***/ }),

/***/ "./src/app/shareds/components/auth-navber/auth-navber.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/shareds/components/auth-navber/auth-navber.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@media screen and (max-width: 992px) {\n    #desktop {\n        display: none;\n    }\n    .navbar {\n        box-shadow: unset !important;\n    }\n}\n\n@media screen and (min-width: 993px) {\n    #mobile {\n        display: none;\n    }\n}\n\n.hide-logo{\n    display: none !important;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc2hhcmVkcy9jb21wb25lbnRzL2F1dGgtbmF2YmVyL2F1dGgtbmF2YmVyLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSTtRQUNJLGFBQWE7SUFDakI7SUFDQTtRQUNJLDRCQUE0QjtJQUNoQztBQUNKOztBQUVBO0lBQ0k7UUFDSSxhQUFhO0lBQ2pCO0FBQ0o7O0FBRUE7SUFDSSx3QkFBd0I7QUFDNUIiLCJmaWxlIjoic3JjL2FwcC9zaGFyZWRzL2NvbXBvbmVudHMvYXV0aC1uYXZiZXIvYXV0aC1uYXZiZXIuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDk5MnB4KSB7XG4gICAgI2Rlc2t0b3Age1xuICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgIH1cbiAgICAubmF2YmFyIHtcbiAgICAgICAgYm94LXNoYWRvdzogdW5zZXQgIWltcG9ydGFudDtcbiAgICB9XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDk5M3B4KSB7XG4gICAgI21vYmlsZSB7XG4gICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgfVxufVxuXG4uaGlkZS1sb2dve1xuICAgIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/shareds/components/auth-navber/auth-navber.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/shareds/components/auth-navber/auth-navber.component.ts ***!
  \*************************************************************************/
/*! exports provided: AuthNavberComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthNavberComponent", function() { return AuthNavberComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../app.url */ "./src/app/app.url.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var src_app_components_services_authen_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/components/_services/authen.service */ "./src/app/components/_services/authen.service.ts");
/* harmony import */ var src_app_cbn_cbn_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/cbn/cbn.url */ "./src/app/cbn/cbn.url.ts");
/* harmony import */ var src_app_cbn_components_profile_services_profile_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/cbn/components/profile/_services/profile.service */ "./src/app/cbn/components/profile/_services/profile.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");









let AuthNavberComponent = class AuthNavberComponent {
    constructor(authenticationService, toastr, profileService, route) {
        this.authenticationService = authenticationService;
        this.toastr = toastr;
        this.profileService = profileService;
        this.route = route;
        this.AppURL = _app_url__WEBPACK_IMPORTED_MODULE_2__["AppURL"];
        this.AuthURL = src_app_cbn_cbn_url__WEBPACK_IMPORTED_MODULE_5__["AuthURL"];
        this.profileService.list$.subscribe(name => (this.displayName = name));
    }
    ngOnInit() {
        this.getUserProfile();
        this.checkDashboard();
    }
    checkDashboard() {
        var element1 = document.getElementById("showLogoDashboard");
        var element2 = document.getElementById("hideLogoDashboard");
        if (this.route.snapshot.routeConfig.path === 'dashboard') {
            element1.classList.remove("hide-logo");
            element2.classList.add("hide-logo");
        }
        else {
            element1.classList.add("hide-logo");
            element2.classList.remove("hide-logo");
        }
    }
    getUserProfile() {
        this.profileService.getProfile()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["first"])())
            .subscribe((response) => {
            if (response.status === true) {
                this.displayName = response.data.name + ' ' + response.data.surname;
            }
            else {
                this.error = response.message;
                if (this.error === 'Invalid authorization token.') {
                    this.authenticationService.logout();
                    location.href = '/login';
                }
            }
        }, error => {
            this.error = error;
        });
    }
    logout() {
        this.toastr.success('Logout Successfully', 'Notice!');
        this.authenticationService.logout();
        location.href = '/login';
    }
    toggleSidebar() {
        // layout-expanded
        var element = document.getElementById("html");
        element.classList.add("layout-transitioning");
        element.classList.add("layout-expanded");
    }
};
AuthNavberComponent.ctorParameters = () => [
    { type: src_app_components_services_authen_service__WEBPACK_IMPORTED_MODULE_4__["AuthenService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_3__["ToastrService"] },
    { type: src_app_cbn_components_profile_services_profile_service__WEBPACK_IMPORTED_MODULE_6__["ProfileService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_8__["ActivatedRoute"] }
];
AuthNavberComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-auth-navber',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./auth-navber.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-navber/auth-navber.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./auth-navber.component.css */ "./src/app/shareds/components/auth-navber/auth-navber.component.css")).default]
    })
], AuthNavberComponent);



/***/ }),

/***/ "./src/app/shareds/components/auth-sidebar/auth-sidebar.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/shareds/components/auth-sidebar/auth-sidebar.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".sidenav-link {\n    padding-left: 50px !important;\n    padding-top: 5px !important;\n    padding-bottom: 5px !important;\n    font-size: 14px;\n}\n\n.tab-active {\n    background-color: #373848;\n}\n\n.active-text {\n    color: #fff !important;\n}\n\n.sidenav-space {\n    margin-bottom: 2.5rem !important;\n}\n\n@media screen and (max-width: 992px) {\n    #desktop {\n        display: none;\n    }\n}\n\n@media screen and (min-width: 993px) {\n    #mobile {\n        display: none;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc2hhcmVkcy9jb21wb25lbnRzL2F1dGgtc2lkZWJhci9hdXRoLXNpZGViYXIuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLDZCQUE2QjtJQUM3QiwyQkFBMkI7SUFDM0IsOEJBQThCO0lBQzlCLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSx5QkFBeUI7QUFDN0I7O0FBRUE7SUFDSSxzQkFBc0I7QUFDMUI7O0FBRUE7SUFDSSxnQ0FBZ0M7QUFDcEM7O0FBRUE7SUFDSTtRQUNJLGFBQWE7SUFDakI7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksYUFBYTtJQUNqQjtBQUNKIiwiZmlsZSI6InNyYy9hcHAvc2hhcmVkcy9jb21wb25lbnRzL2F1dGgtc2lkZWJhci9hdXRoLXNpZGViYXIuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zaWRlbmF2LWxpbmsge1xuICAgIHBhZGRpbmctbGVmdDogNTBweCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctdG9wOiA1cHggIWltcG9ydGFudDtcbiAgICBwYWRkaW5nLWJvdHRvbTogNXB4ICFpbXBvcnRhbnQ7XG4gICAgZm9udC1zaXplOiAxNHB4O1xufVxuXG4udGFiLWFjdGl2ZSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzM3Mzg0ODtcbn1cblxuLmFjdGl2ZS10ZXh0IHtcbiAgICBjb2xvcjogI2ZmZiAhaW1wb3J0YW50O1xufVxuXG4uc2lkZW5hdi1zcGFjZSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMi41cmVtICFpbXBvcnRhbnQ7XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDk5MnB4KSB7XG4gICAgI2Rlc2t0b3Age1xuICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgIH1cbn1cblxuQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogOTkzcHgpIHtcbiAgICAjbW9iaWxlIHtcbiAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG59Il19 */");

/***/ }),

/***/ "./src/app/shareds/components/auth-sidebar/auth-sidebar.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/shareds/components/auth-sidebar/auth-sidebar.component.ts ***!
  \***************************************************************************/
/*! exports provided: AuthSidebarComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthSidebarComponent", function() { return AuthSidebarComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_app_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/app.url */ "./src/app/app.url.ts");
/* harmony import */ var src_app_cbn_cbn_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/cbn/cbn.url */ "./src/app/cbn/cbn.url.ts");
/* harmony import */ var src_app_components_services_authen_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/components/_services/authen.service */ "./src/app/components/_services/authen.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_cbn_components_profile_services_profile_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/cbn/components/profile/_services/profile.service */ "./src/app/cbn/components/profile/_services/profile.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");










let AuthSidebarComponent = class AuthSidebarComponent {
    constructor(authenticationService, toastr, route, profileService) {
        this.authenticationService = authenticationService;
        this.toastr = toastr;
        this.route = route;
        this.profileService = profileService;
        this.AppURL = src_app_app_url__WEBPACK_IMPORTED_MODULE_2__["AppURL"];
        this.AuthURL = src_app_cbn_cbn_url__WEBPACK_IMPORTED_MODULE_3__["AuthURL"];
        this.showOverlay = true;
        this.url = src_environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].apiUrl;
        this.profileService.list$.subscribe(name => (this.displayName = name));
        this.profileService.avatar$.subscribe(avatar => (this.avatar = avatar));
    }
    ngOnInit() {
        this.getUserProfile();
    }
    getUserProfile() {
        this.profileService.getProfile()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["first"])())
            .subscribe((response) => {
            if (response.status === true) {
                this.avatar = response.data.avatar;
                this.displayName = response.data.username;
                this.showOverlay = false;
            }
            else {
                this.error = response.message;
                if (this.error === 'Invalid authorization token.') {
                    this.authenticationService.logout();
                    location.href = '/login';
                }
            }
        }, error => {
            this.error = error;
        });
    }
    logout() {
        this.toastr.success('Logout Successfully', 'Notice!');
        this.authenticationService.logout();
        location.href = '/login';
    }
    toggleSidebar() {
        // layout-expanded
        var element = document.getElementById("html");
        element.classList.remove("layout-expanded");
    }
    setActive() {
        var boxPersonal = document.getElementById('checkActive');
        var textPersonal = document.getElementById('checkActive-text');
        var boxOz = document.getElementById('oz-checkActive');
        var textOz = document.getElementById('oz-checkActive-text');
        if (this.route.snapshot.routeConfig.path === 'projects') {
            return 'active';
        }
        else if (this.route.snapshot.routeConfig.path === 'project-view/:id') {
            boxPersonal.classList.add('tab-active');
            textPersonal.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'projects-list') {
            boxPersonal.classList.add('tab-active');
            textPersonal.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'project-add-member/:projectId') {
            boxPersonal.classList.add('tab-active');
            textPersonal.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'project-payment-view/:id') {
            boxPersonal.classList.add('tab-active');
            textPersonal.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'user-update-address/:projectmemberId') {
            boxPersonal.classList.add('tab-active');
            textPersonal.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organizations') {
            return 'active';
        }
        else if (this.route.snapshot.routeConfig.path === 'organizations-create') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organizations-list') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-add-member/:organizeId') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-view/:id') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-project-view-payment/:id') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-project-view/:id/:organizeMemberId') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-projects-list/:organizeId/:organizeMemberId') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-projects-add-member/:projectId/:organizeId/:organizeMemberId') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-payment-create/:id/:organizeMemberId') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-project-view/:id') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-infomation/:id') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
        else if (this.route.snapshot.routeConfig.path === 'organization-update-address/:projectmemberId/:organizationmemberId') {
            boxOz.classList.add('tab-active');
            textOz.classList.add('active-text');
        }
    }
};
AuthSidebarComponent.ctorParameters = () => [
    { type: src_app_components_services_authen_service__WEBPACK_IMPORTED_MODULE_4__["AuthenService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_5__["ToastrService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["ActivatedRoute"] },
    { type: src_app_cbn_components_profile_services_profile_service__WEBPACK_IMPORTED_MODULE_7__["ProfileService"] }
];
AuthSidebarComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-auth-sidebar',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./auth-sidebar.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shareds/components/auth-sidebar/auth-sidebar.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./auth-sidebar.component.css */ "./src/app/shareds/components/auth-sidebar/auth-sidebar.component.css")).default]
    })
], AuthSidebarComponent);



/***/ }),

/***/ "./src/app/shareds/shareds.module.ts":
/*!*******************************************!*\
  !*** ./src/app/shareds/shareds.module.ts ***!
  \*******************************************/
/*! exports provided: SharedsModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedsModule", function() { return SharedsModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _components_auth_navber_auth_navber_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/auth-navber/auth-navber.component */ "./src/app/shareds/components/auth-navber/auth-navber.component.ts");
/* harmony import */ var _components_auth_content_auth_content_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/auth-content/auth-content.component */ "./src/app/shareds/components/auth-content/auth-content.component.ts");
/* harmony import */ var _components_auth_sidebar_auth_sidebar_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/auth-sidebar/auth-sidebar.component */ "./src/app/shareds/components/auth-sidebar/auth-sidebar.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");







let SharedsModule = class SharedsModule {
};
SharedsModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_components_auth_navber_auth_navber_component__WEBPACK_IMPORTED_MODULE_3__["AuthNavberComponent"], _components_auth_content_auth_content_component__WEBPACK_IMPORTED_MODULE_4__["AuthContentComponent"], _components_auth_sidebar_auth_sidebar_component__WEBPACK_IMPORTED_MODULE_5__["AuthSidebarComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"],
        ],
        exports: [
            _components_auth_navber_auth_navber_component__WEBPACK_IMPORTED_MODULE_3__["AuthNavberComponent"],
            _components_auth_content_auth_content_component__WEBPACK_IMPORTED_MODULE_4__["AuthContentComponent"],
            _components_auth_sidebar_auth_sidebar_component__WEBPACK_IMPORTED_MODULE_5__["AuthSidebarComponent"]
        ]
    })
], SharedsModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    apiUrl: 'https://wcapi.cbnthailand.com'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/home/Documents/DEVPA/CBN/cbn-web-user/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map